import { Options, PropsValue } from "react-select";

import { SelectOptionTree } from "../types";

export const findElementByHid = (
  hid: PropsValue<number>,
  tree: Options<SelectOptionTree>,
): SelectOptionTree[] | SelectOptionTree | undefined => {
  const stack = [...tree];
  const result = new Array<SelectOptionTree>();

  while (stack.length) {
    const item = stack.pop();

    if (!item) {
      continue;
    }

    if (Array.isArray(hid)) {
      if (hid.includes(item.value)) {
        result.push(item);
      }
    } else {
      return item;
    }

    item.options?.forEach((item) => {
      stack.push(item);
    });
  }

  return result;
};
